// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractBadgeProps = {
    /**
     * The HTML tag that should be used.
     */
    tag: {
        type: String,
        required: false,
        default: 'span'
    }
};
